import { overrideBaseLocale } from './base-config';
export var enSA = overrideBaseLocale('en-SA', {});
//# sourceMappingURL=en-SA.js.map